<!-- 视频详情页 -->
<template>
  <div class="all">
    <Top :hasShare="false" />
    <!-- 顶部 -->
    <div class="top">
      <!-- 标题 -->
      <div class="title">
        关于开展医保药品、医用耗材产品关于信息维护的通知开展医
      </div>
      <!-- logo -->
      <div class="logo">
        <div class="left">
          <van-image
            round
            width="50px"
            height="50px"
            fit="cover"
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
          />
        </div>
        <div class="right">
          <div class="title">科技资讯</div>
          <div class="time">发布于：2021年7月26日</div>
        </div>
      </div>
      <!-- 视频 -->
      <div class="video">
        <video
          src="http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
          width="100%"
          height="100%"
          preload
          controls
        ></video>
      </div>
      <!-- 描述 -->
      <div class="describe">
        <p>
          各省、自治区、直辖市及新疆生产建设兵团人力资源社会保障厅（局）、新闻出版局，中央和国家机部委、各直属机构人事部门，中央军委政治工作部宣传局，各中央企业人事部门：
        </p>
      </div>
    </div>
    <div class="below">
      <div class="title">最新资讯</div>
      <div class="list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
        >
          <van-cell>
            <div class="list">
              <div class="left" v-if="true">
                <img src="https://img01.yzcdn.cn/vant/cat.jpeg" alt="" />
              </div>
              <div class="right">
                <div class="title">
                  关于开展美国医保药品nia医药 保药品、医用
                </div>
                <div class="bottom">
                  <div class="left">01:08</div>
                  <div class="right">
                    <span>浏览：</span>
                    <span>1608</span>
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
          <van-cell>
            <div class="list">
              <div class="left" v-if="true">
                <img src="https://img01.yzcdn.cn/vant/cat.jpeg" alt="" />
              </div>
              <div class="right">
                <div class="title">
                  关于开展美国医保药品nia医药 保药品、医用
                </div>
                <div class="bottom">
                  <div class="left">01:08</div>
                  <div class="right">
                    <span>浏览：</span>
                    <span>1608</span>
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/views/mobileView/detail/components/Header.vue';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Top,
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onLoad() {},
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>
<style lang='scss' scoped>
::v-deep iframe {
  max-width: 100% !important;
  max-height: 200px !important;
}
::v-deep img {
  margin: 20px 0;
  max-width: 100% !important;
}
.all {
  background: #e5e5e5;
  .top {
    overflow: hidden;
    padding: 0 16px 26px 16px;
    background-color: #fff;
    .title {
      font-size: 18px;
      font-family: PingFang;
      font-weight: bold;
      color: #303030;
    }
    .logo {
      margin-top: 14px;
      display: flex;
      .left {
        margin-right: 10px;
      }
      .right {
        .title {
          padding-top: 4px;
          font-size: 15px;
          font-family: PingFang;
          color: #333333;
        }
        .time {
          padding-top: 4px;
          font-size: 10px;
          font-family: PingFang;
          font-weight: 500;
          color: #999999;
        }
      }
    }
    .video {
      padding: 20px 0;
      video {
        border-radius: 5px;
      }
    }
    .describe {
      font-size: 15px;
      font-family: PingFang;
      color: #303030;
    }
  }
  .below {
    padding: 24px 16px 0 16px;
    margin-top: 8px;
    width: 100%;
    height: 200px;
    background: #fff;
    .title {
      font-size: 18px;
      font-family: PingFang;
      font-weight: bold;
      color: #303030;
    }
    .list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      .left {
        img {
          width: 123px;
          height: 68px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      .right {
        width: inherit;
        .title {
          min-height: 46px;
          font-size: 16px;
          font-family: PingFang;
          color: #303030;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          color: #333333;
          .left {
            font-size: 12px;
            font-family: PingFang;
          }
          .right {
            font-size: 12px;
            font-family: PingFang;
            span {
              &:last-child {
                margin-left: 6px;
              }
            }
          }
        }
      }
    }
  }
}
::v-deep .van-cell {
  padding: 16px 0;
}
</style>